var EntityProfileEnum = /* @__PURE__ */ ((EntityProfileEnum2) => {
  EntityProfileEnum2["ENTITY_SECTION_ABOUT"] = "entity-about--text";
  EntityProfileEnum2["ENTITY_TAB_TRIGGER"] = "entity-tab--trigger";
  EntityProfileEnum2["ENTITY_SHOW_MORE_BUTTON"] = "entity-about--show-more-button";
  EntityProfileEnum2["ENTITY_SHOW_MORE_COMMENTS_BUTTON"] = "entity--show-more-comments-button";
  EntityProfileEnum2["ENTITY_COUNT_RATING"] = "entity--count-rating";
  EntityProfileEnum2["ENTITY_COUNT_AVERAGE"] = "entity--average-rating-on-card";
  EntityProfileEnum2["ENTITY_RATING_CARD"] = "entity--card";
  EntityProfileEnum2["ENTITY_COMMENT_CONTENT"] = "entity--comment-content";
  EntityProfileEnum2["ENTITY_COMMENT_SESSION"] = "entity-comment--section";
  EntityProfileEnum2["ENTITY_COMMENT_STAR"] = "comment-rating--entity-comment-start";
  EntityProfileEnum2["ENTITY_COMMENT_DATE"] = "comment-date--entity-comment";
  EntityProfileEnum2["ENTITY_RATING_CONTAINER"] = "entity--rating-container";
  EntityProfileEnum2["ENTITY_COMMENT_TEXT"] = "entity--comment-text-";
  EntityProfileEnum2["ENTITY_BUTTON_SHOW_MORE_COMMENT"] = "entity--show-more-button";
  EntityProfileEnum2["ENTITY_ACTION_LOADING"] = "entity--action-loading";
  EntityProfileEnum2["ENTITY_BAR_CONTAINER"] = "entity-bar-container";
  EntityProfileEnum2["ENTITY_BAR"] = "entity-bar";
  EntityProfileEnum2["ENTITY_SECTION_ICON"] = "entity-section-icon";
  EntityProfileEnum2["ENTITY_TAB_CONTAINER"] = "entity-tab-container";
  EntityProfileEnum2["ENTITY_TAB_CONTENT"] = "entity-tab-content";
  EntityProfileEnum2["ENTITY_AVERAGE_RATING"] = "entity--average-rating";
  EntityProfileEnum2["ENTITY_FULL_COMMENT_COUNT"] = "entity--full-comment-count";
  EntityProfileEnum2["ENTITY_EMPTY_RATING"] = "entity--empty-rating";
  EntityProfileEnum2["ENTITY_RESPONSE_COMMENT_TEXT"] = "response-comment-text--entity-comment";
  EntityProfileEnum2["ENTITY_EXCELLENT_RATING"] = "excellent-rating--entity-rating";
  EntityProfileEnum2["ENTITY_RATING_COUNT"] = "rating-count--entity-rating";
  EntityProfileEnum2["ENTITY_FAVORITE_BUTTON"] = "favorite-button--entity-profile";
  EntityProfileEnum2["ENTITY_PROFILE_ACTIONS_COMPACT"] = "actions-compact--entity-profile";
  EntityProfileEnum2["ENTITY_PROFILE_ACTIONS_DESKTOP"] = "actions-desktop--entity-profile";
  EntityProfileEnum2["ENTITY_SPECIALTIES_AND_RQE"] = "entity-specialties-and-rqe";
  EntityProfileEnum2["ENTITY_SPECIALTIES_AND_RQE_LINE"] = "entity-specialties-and-rqe--line";
  EntityProfileEnum2["ENTITY_MAIN_POST_GRADUATION"] = "entity-main-post-graduation";
  EntityProfileEnum2["ENTITY_OTHER_POST_GRADUATIONS_LINK"] = "entity-other-post-graduations-link";
  EntityProfileEnum2["ENTITY_COMMENTS_SORT"] = "comments-sort--entity-profile";
  EntityProfileEnum2["ENTITY_COMMENTS_LOADING"] = "comments-loading--entity-profile";
  EntityProfileEnum2["SELECT_MENU_TRIGGER"] = "select-menu--trigger";
  EntityProfileEnum2["SELECT_MENU_OPTION"] = "select-menu--option";
  return EntityProfileEnum2;
})(EntityProfileEnum || {});
export {
  EntityProfileEnum
};
